var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"30px"}},[_c('div',[_vm._v(" "+_vm._s(_vm.dateAndWeek)+" ")]),_c('div',[_vm._v(_vm._s(_vm.wea))]),_c('div',[_vm._v(_vm._s(_vm.tem)+" ℃")])])
}
var staticRenderFns = []

export { render, staticRenderFns }